module.exports = __webpack_public_path__ + "media/images/content/icon_pet-6b65a9692d98e66daa1ba2a4eedc6d68.svg";